/**
 * 共建店导入 2020-02-20
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool,utils_tool, framework_tool } from '@/tool'
let { WizTypography,WizButton, WizSpin,WizTreeSelect,WizModal } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import {modelUtils} from '@/utils';
let {Session} = utils_tool;



class BankQuestionImport extends WizContainer {

  componentName = 'bankQuestionImport';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _componentDidMount() {

    this.doActions([{
        path: `questionType/normalNodeList`,
        payload: {
          key: `questionType@treeData`,
          apiParams: {type:2,state:1}
        }
    },
    ],);
    const arr = [];
    this.setState({
        data: arr,
        treeData:[],
        orgNodeCategoryTree:[]
    });
}

  _handldImport(nextProps, nextState) {
    let o = nextProps['questionTypeImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({

        title:'导入成功',

        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>,
      })
      return true;
    } else {
      let data = o['msg'];
      let str = data.replace(/<br\/>/g,"\r\n")

      WizModal.error({

        title:'导入失败',

        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>,
      })
     // wizNotice.error(str||"导入数据出错，请联系相关人员")
      return true;
    }
  }
  _treeData(nextProps, nextState) {
    let o = nextProps['treeData']
    if (o['success']) {
        nextState['treeData'] = o['data']
    }
    return true
  }

  propsAndStateOnChange = {
    treeData:this._treeData.bind(this),
    questionTypeImport: this._handldImport.bind(this),
  }


  _render() {
    const{treeData,type} = this.state
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '题目导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_questionTemp,
      }

    }
    let submit  = (file, fileData, other) => {
        const{categoryId} = other
      let apiPath = 'bankQuestion/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "type":2,
            "categoryId":categoryId || null
          }
        }
      });
    }

    let other = [
        {
          /**
           * item的参数
           */
          item: { label: '题目分类',required:true },
          /**
           * 渲染内容的方法
           */
          comp: (callback) => {
            return (
              <WizTreeSelect treeData={treeData} multiple={true} onChange={(value) => {
              callback && callback('categoryId', value) }} allowClear style={{ width: '100%' }}>
              </WizTreeSelect>
            )
          }
        },
      ]

    let { bankQuestionLoading,questionTypeLoading } = this.props;
    return (
      <WizSpin tip={'加载中'} spinning={questionTypeLoading}>
      <WizSpin tip={'文件上传中'} spinning={bankQuestionLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionType,bankQuestion } = state;
  const questionTypeImport = modelUtils.getModelEntity(bankQuestion, 'import');
  const treeData = modelUtils.getModelEntity(questionType, 'questionType@treeData');


  //获取loading的方式
  const load = modelUtils.getLoadingState(state,[ 'questionType','bankQuestion'])
  return {
    questionTypeImport,
    treeData,
    ...load
  }
};

export default connect(mapStateToProps)(BankQuestionImport);
